<template>
  <vx-card id="manager-invoice-view" v-if="requestDetails">
    <invoice-data-view :invoice="invoice" :request="request" :request-details="requestDetails" />
    <vs-row class="mb-base" v-if="payment">
      <vx-card no-shadow card-border :subtitle="$t('payments.details')">
        <vs-row class="mb-2">
          <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-3">
            <vs-row class="font-semibold"> {{ $t('payments.status') }}: </vs-row>
            <vs-row class="mt-3">{{
              payment.isVerified ? $t('payments.is_verified') : $t('payments.is_not_verified')
            }}</vs-row>
          </div>
          <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-3">
            <vs-row class="font-semibold">{{ $t('payments.amount') }}:</vs-row>
            <vs-row class="mt-3">{{ payment.amount | toman }}</vs-row>
          </div>
          <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-3">
            <vs-row class="font-semibold">{{ $t('entity.created_at') }}:</vs-row>
            <vs-row class="mt-3">{{ payment.created_at | datetime }}</vs-row>
          </div>
          <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-3" v-if="payment.updated_at">
            <vs-row class="font-semibold">{{ $t('entity.updated_at') }}:</vs-row>
            <vs-row class="mt-3">{{ payment.updated_at | datetime }}</vs-row>
          </div>
        </vs-row>
        <vs-row class="font-semibold"> {{ $t('payments.pairs') }}: </vs-row>
        <vs-row class="mb-2 mt-3 flex gap-2">
          <div
            v-for="p in payment.pairs"
            class="py-3 px-5 bg-success-gradient text-white font-bold rounded"
            :key="p"
          >
            <div>{{ $t('entity.id') }} {{ p.userIdentity }}</div>
            <div>
              {{ p.amount | toman }}
            </div>
          </div>
        </vs-row>
        <template v-if="payment.errorsData.length">
          <vs-row class="font-semibold"> {{ $t('payments.errors') }}: </vs-row>
          <vs-row class="mb-2 mt-3 flex gap-2">
            <vs-alert v-for="error in payment.errorsData" color="danger" :key="error">
              <span class="text-sm">{{ error.occurred_at | datetime }} </span>:
              {{ Object.values(error.error)[0] }}
            </vs-alert>
          </vs-row>
        </template>
        <vs-row vs-justify="flex-end" class="mt-3">
          <a
            :href="`https://app.payping.ir/report/transactions/${payment.code}`"
            target="_blank"
            class="bg-primary text-white rounded p-3"
          >
            {{ $t('payments.goto_payping_details') }}</a
          >
        </vs-row>
      </vx-card>
    </vs-row>
  </vx-card>
</template>

<script>
import InvoiceDataView from '@/views/pages/invoice/InvoiceDataView'
import modulePayping from '@/store/payping/modulePayping'

export default {
  name: 'AdminInvoiceView',
  components: { InvoiceDataView },
  data() {
    return {
      invoice: {},
      request: {},
      payment: null,
      requestDetails: null,
      payBtnDisable: false
    }
  },
  created() {
    this.$vs.loading()
    if (!modulePayping.isRegistered) {
      this.$store.registerModule('payping', modulePayping)
      modulePayping.isRegistered = true
    }
    this.$store
      .dispatch('invoice/fetchInvoice', this.$route.params.id)
      .then(res => {
        this.invoice = JSON.parse(JSON.stringify(res.data))

        this.$store
          .dispatch('request/fetchHealthRequestById', this.invoice.request.id)
          .then(res => {
            this.request = JSON.parse(JSON.stringify(res.data))
            this.$store
              .dispatch('request/fetchRequestDetailsBySubject', {
                id: this.invoice.request.id,
                subject: this.request.subject,
                category: this.request.category
              })
              .then(res => {
                this.requestDetails = res.data
              })
          })
          .finally(() => this.$vs.loading.close())

        if (this.invoice.paypingPaymentId)
          this.$store.dispatch('payping/fetchPayment', this.invoice.paypingPaymentId).then(res => {
            this.payment = res.data
          })
      })
      .catch(() => this.$vs.loading.close())
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>
